export const MA_SETTINGS_LOADER = {
  desktop: `<div class="cui-grid cui-container -spacing--top-64 -spacing--bottom-120">
  <div class="cui-row">
    <div class="cui-col-xl-8 cui-col-lg-10 cui-col-md-12">
      <div class="cui-skeleton-paragraph -spacing--bottom-40">
        <div class="cui-skeleton-paragraph__content" style="width: 160px">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--large -spacing--bottom-40">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="height: 64px;"></div>
      </div>
      <div class="-spacing--top-24 -spacing--bottom-24" style="display: flex; flex-direction: column; gap: 48px;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div class="cui-skeleton-rectangle" style="width: min(320px, 46%); display: flex; flex-direction: column; row-gap: 8px">
            <div class="cui-skeleton__item" style="height: 28px;"></div>
            <div class="cui-skeleton__item" style="height: 18px;"></div>
          </div>
          <div class="cui-skeleton-rectangle" style="width: 96px">
            <div class="cui-skeleton__item" style="height: 28px;"></div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div class="cui-skeleton-rectangle" style="width: min(320px, 46%); display: flex; flex-direction: column; row-gap: 8px">
            <div class="cui-skeleton__item" style="height: 28px;"></div>
            <div class="cui-skeleton__item" style="height: 18px;"></div>
          </div>
          <div class="cui-skeleton-rectangle" style="width: 96px">
            <div class="cui-skeleton__item" style="height: 28px;"></div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div class="cui-skeleton-rectangle" style="width: min(320px, 46%); display: flex; flex-direction: column; row-gap: 8px">
            <div class="cui-skeleton__item" style="height: 28px;"></div>
            <div class="cui-skeleton__item" style="height: 18px;"></div>
          </div>
          <div class="cui-skeleton-rectangle" style="width: 96px">
            <div class="cui-skeleton__item" style="height: 28px;"></div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div class="cui-skeleton-rectangle" style="width: min(320px, 46%); display: flex; flex-direction: column; row-gap: 8px">
            <div class="cui-skeleton__item" style="height: 28px;"></div>
            <div class="cui-skeleton__item" style="height: 18px;"></div>
          </div>
          <div class="cui-skeleton-rectangle" style="width: 96px">
            <div class="cui-skeleton__item" style="height: 28px;"></div>
          </div>
        </div>
      </div>  
    </div>
  </div>
</div>`
};
